import { render, staticRenderFns } from "./QuickActionReceipt.vue?vue&type=template&id=2f7c121c&scoped=true"
import script from "./QuickActionReceipt.vue?vue&type=script&lang=js"
export * from "./QuickActionReceipt.vue?vue&type=script&lang=js"
import style0 from "./QuickActionReceipt.vue?vue&type=style&index=0&id=2f7c121c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7c121c",
  null
  
)

export default component.exports